import { useState } from "react";

export interface ModalType<DataT = never, TypeT = never> {
  open: boolean;
  type?: "ADD" | "UPDATE" | "VIEW" | "SUCCESS" | "CONFIRM" | "IMPORT" | TypeT;
  data?: DataT;
}

export default function useModal<DataT = never, TypeT = never>(
  reRender?: () => void
) {
  const [open, setOpen] = useState<ModalType<DataT, TypeT>>({
    open: false,
    type: undefined,
    data: undefined,
  });

  const handleClose = (val?: boolean) => {
    if (val && reRender) {
      reRender();
    }

    setOpen({
      open: false,
      type: undefined,
      data: undefined,
    });
  };

  const handleOpen = ({
    type = undefined,
    data = undefined,
  }: Omit<ModalType<DataT, TypeT>, "open">) => {
    setOpen({
      open: true,
      type,
      data,
    });
  };

  return { open, handleOpen, handleClose };
}
